export enum BooleanType {
  TRUE = 'true',
  FALSE = 'false',
}
